export default __webpack_public_path__ + "img/ernnjEJk.83598d8c.svg";